import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/shared/shared.service';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
    products;
    loadingProducts;
    searchString: ' ';
    orderProductsBy = 'alias';
    productToEdit;
    editMode = false;
    constructor(public sharedService: SharedService) {}

    ngOnInit() {
        this.getProducts();
    }

    public getProducts() {
        this.loadingProducts = true;
        this.loadingProducts = this.sharedService.getAllProductsWithInactive().subscribe(res => {
            this.products = Object.keys(res).map(i => {
                res[i]['aktiv'] = res[i]['aktiv'] == 0 ? false : true;
                return res[i];
            });
            this.loadingProducts = false;
        });
    }

    public changeStatus(prod) {
        this.loadingProducts = this.sharedService.changeProductStatus(prod).subscribe(res => {
            this.sharedService.productsWithInactive = undefined;
            this.sharedService.products = undefined;
            this.getProducts();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/products/products.component.ts